import { screenshotsAccordion } from '../utils/screenshots';

// const addHomeVideoAttribute = () => {
//   const homeVideo = document.querySelector('#home-hero video source');

//   if (homeVideo) {
//     //  if (isMobile) {
//     //      homeVideo.setAttribute('data-src', '/assets/home-hero-mobile.mp4');
//     //} else {
//     homeVideo.setAttribute('data-src', '/assets/home-hero-desktop-vw.mp4');
//     //}
//   };
// }

document.addEventListener('DOMContentLoaded', function (e) {
  screenshotsAccordion();
});
